var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const LinkStyle = styled.div `
  line-height: ${props => props.theme.fonts.lineHeight};
  display: ${props => (props.isBlock ? 'block' : 'inline-block')};
  margin-top: 0;
  cursor: pointer;
  margin-bottom: 0;
  font-family: ${props => props.theme.fonts.fontFamily};
  ${''}
  color : ${props => props.theme.utils.getColor(props.color)};
  ${''}
  font-size: ${props => props.theme.utils.getSize(props.size)};
  ${''}
  font-weight: ${props => props.weight};
  font-style: ${props => props.fontStyle};
  text-decoration: ${props => props.decoration};
  text-align: ${props => props.align};
  overflow-wrap: ${(props) => props.overflowWrap};
    & > a {
      color: ${props => props.theme.utils.getColor(props.color)} !important;
      font-style: ${props => props.fontStyle} !important;
      text-decoration: ${props => props.decoration};
    };
    & > a:visited {
      color: ${props => props.visited ? props.theme.utils.getColor(props.visited) : props.theme.utils.getColor(props.color)} !important;
      font-style: ${props => props.fontStyle} !important;
      text-decoration: ${props => props.decoration};
    };
    & > a:hover {
      color: ${props => props.theme.utils.getColor(props.hover)} !important;
    }
    & > *:hover {
      color: ${props => props.theme.utils.getColor(props.hover)} !important;
    }
`;
const Link = (_a) => {
    var { children, color = 'main', size = 'article', weight = 'normal', fontStyle = 'normal', decoration = 'none', align = 'left', hover = '', visited = 'mainLight', overflowWrap, isBlock = false } = _a, props = __rest(_a, ["children", "color", "size", "weight", "fontStyle", "decoration", "align", "hover", "visited", "overflowWrap", "isBlock"]);
    return (_jsx(LinkStyle, Object.assign({ color: color, size: size, weight: weight, fontStyle: fontStyle, decoration: decoration, align: align, isBlock: isBlock, hover: hover, visited: visited, overflowWrap: overflowWrap }, props, { children: children })));
};
export default Link;
